module.exports = "/_next/static/images/coins-monotone-c459d6c7e5c9115e6d726c0494f40825.svg";